import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { SnackbarComponent } from "../snackbar.component";

@Component({
  selector: "app-warning-message",
  imports: [MatIconModule, TranslatePipe],
  templateUrl: "./warning-message.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./warning-message.component.less",
})
export class WarningMessageComponent extends SnackbarComponent<string> {
  public constructor() {
    super();
  }
}
